import { DEFAULT_MASK } from "../../../Shared/components/PostalCodeTextMask/usePostalCodeTextMask";
/**
 * =========================
 * Stable Singleton Defaults
 * =========================
 *
 * These objects are created once at module load and reused everywhere they are imported.
 * Their references never change, ensuring stability for memoization and context consumers.
 */
export const stableDefaultKeyMap = new Map();
const stableDefaultCompanyText = [];
const stableDefaultTokenMap = new Map();
const stableDefaultPostalCodeMasks = DEFAULT_MASK;
/**
 * =========================
 * Stable Default Nested Objects
 * =========================
 *
 * Nested objects are also stable singletons. These provide default values for
 * deeply nested parts of the context to prevent unnecessary re-renders and
 * ensure reference equality until actual company data is loaded.
 */
const stableDefaultMyMealsCompanyText = {
    AddMealToShowMenu: "",
    CutOffDayText: "",
    DeliveryDayText: "",
    EditMealQuantityModal: "",
    MealDayAddFutureMeal: "",
    MealDayMessagesAddOns: "",
    MealDayMessagesAvailable: "",
    MealDayMessagesBuyMeals: "",
    MealDayMessagesNotAvailable: "",
    MealDayMessagesSelected: "",
    MealQuantityAddedText: "",
    MealQuantityRemovedText: "",
    NoDefaultMealsText: "",
    PaymentDialogCancelBtn: "",
    PaymentDialogConfirmBtn: "",
    PaymentDialogTitle: "",
    QuickSaveChangesBtnText: "",
    QuickSavePayBtnText: "",
    QuickSaveToolTipText: "",
    SkipDayModalDescription: "",
    SkipDayModalTitle: "",
    Title: "",
};
const stableDefaultOrderHistoryCompanyText = {
    MealsButtonSubText: "",
    NoMealsSelectedText: "",
};
const stableDefaultRecipeControlCompanyText = {
    SelectedQuantityText: "",
};
const stableDefaultCulture = {
    countryCode: "US",
    cultureInfo: "en-US",
    currency: "USD",
};
/**
 * =========================
 * Full Default Context State
 * =========================
 *
 * This is exported as a stable singleton. Consumers of CompanyContext can safely
 * use this object before actual company data loads. Any dynamic values (e.g., keyMap)
 * will be replaced with memoized versions when data becomes available.
 *
 * Note: If you spread or copy this object, the original singletons remain unchanged.
 */
export const defaultContextState = {
    companySettingsCountry: "",
    companyText: stableDefaultCompanyText,
    myMealsCompanyText: stableDefaultMyMealsCompanyText,
    orderHistoryCompanyText: stableDefaultOrderHistoryCompanyText,
    recipeControlCompanyText: stableDefaultRecipeControlCompanyText,
    companyUsesKlaviyo: false,
    companyUsesSMS: false,
    culture: stableDefaultCulture,
    displayName: "",
    doesCompanyHaveOrderPage: false,
    footerAttributionMD: "[Meal Delivery Software By MealTrack](https://mealtrack.com/?utm_campaign=AppReferral&utm_source=MT&utm_medium={CompanyName})",
    keys: [],
    keyMap: stableDefaultKeyMap,
    loading: true,
    name: "",
    navOrderButtonText: "Order Now",
    openedFromMobileApp: false,
    orderNowLink: "",
    postalCodeMasks: stableDefaultPostalCodeMasks,
    showPricesIfZero: false,
    startSunday: false,
    tokenMap: stableDefaultTokenMap,
    url: "",
    error: undefined,
};
